// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: wex.proto
/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
export const protobufPackage = "taf";
export var Wex_WexStreamType;
(function (Wex_WexStreamType) {
    Wex_WexStreamType[Wex_WexStreamType["UNKNOWN_STREAM_TYPE"] = 0] = "UNKNOWN_STREAM_TYPE";
    Wex_WexStreamType[Wex_WexStreamType["LIVE"] = 1] = "LIVE";
    Wex_WexStreamType[Wex_WexStreamType["REPLAY"] = 2] = "REPLAY";
    Wex_WexStreamType[Wex_WexStreamType["RECORDING"] = 3] = "RECORDING";
    Wex_WexStreamType[Wex_WexStreamType["TIMESHIFT"] = 4] = "TIMESHIFT";
    Wex_WexStreamType[Wex_WexStreamType["VOD_MOVIE"] = 5] = "VOD_MOVIE";
    Wex_WexStreamType[Wex_WexStreamType["VOD_EPISODE"] = 6] = "VOD_EPISODE";
    Wex_WexStreamType[Wex_WexStreamType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Wex_WexStreamType || (Wex_WexStreamType = {}));
export function wex_WexStreamTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "UNKNOWN_STREAM_TYPE":
            return Wex_WexStreamType.UNKNOWN_STREAM_TYPE;
        case 1:
        case "LIVE":
            return Wex_WexStreamType.LIVE;
        case 2:
        case "REPLAY":
            return Wex_WexStreamType.REPLAY;
        case 3:
        case "RECORDING":
            return Wex_WexStreamType.RECORDING;
        case 4:
        case "TIMESHIFT":
            return Wex_WexStreamType.TIMESHIFT;
        case 5:
        case "VOD_MOVIE":
            return Wex_WexStreamType.VOD_MOVIE;
        case 6:
        case "VOD_EPISODE":
            return Wex_WexStreamType.VOD_EPISODE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Wex_WexStreamType.UNRECOGNIZED;
    }
}
export function wex_WexStreamTypeToJSON(object) {
    switch (object) {
        case Wex_WexStreamType.UNKNOWN_STREAM_TYPE:
            return "UNKNOWN_STREAM_TYPE";
        case Wex_WexStreamType.LIVE:
            return "LIVE";
        case Wex_WexStreamType.REPLAY:
            return "REPLAY";
        case Wex_WexStreamType.RECORDING:
            return "RECORDING";
        case Wex_WexStreamType.TIMESHIFT:
            return "TIMESHIFT";
        case Wex_WexStreamType.VOD_MOVIE:
            return "VOD_MOVIE";
        case Wex_WexStreamType.VOD_EPISODE:
            return "VOD_EPISODE";
        case Wex_WexStreamType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var Wex_PlayerErrors;
(function (Wex_PlayerErrors) {
    Wex_PlayerErrors[Wex_PlayerErrors["UNKNOWN_ERROR"] = 0] = "UNKNOWN_ERROR";
    Wex_PlayerErrors[Wex_PlayerErrors["STREAM_CANNOT_PLAY"] = 1] = "STREAM_CANNOT_PLAY";
    Wex_PlayerErrors[Wex_PlayerErrors["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Wex_PlayerErrors || (Wex_PlayerErrors = {}));
export function wex_PlayerErrorsFromJSON(object) {
    switch (object) {
        case 0:
        case "UNKNOWN_ERROR":
            return Wex_PlayerErrors.UNKNOWN_ERROR;
        case 1:
        case "STREAM_CANNOT_PLAY":
            return Wex_PlayerErrors.STREAM_CANNOT_PLAY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Wex_PlayerErrors.UNRECOGNIZED;
    }
}
export function wex_PlayerErrorsToJSON(object) {
    switch (object) {
        case Wex_PlayerErrors.UNKNOWN_ERROR:
            return "UNKNOWN_ERROR";
        case Wex_PlayerErrors.STREAM_CANNOT_PLAY:
            return "STREAM_CANNOT_PLAY";
        case Wex_PlayerErrors.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var Wex_PlayerEvents;
(function (Wex_PlayerEvents) {
    Wex_PlayerEvents[Wex_PlayerEvents["UNKNOWN_EVENT"] = 0] = "UNKNOWN_EVENT";
    Wex_PlayerEvents[Wex_PlayerEvents["PAUSED"] = 1] = "PAUSED";
    Wex_PlayerEvents[Wex_PlayerEvents["STOPPED"] = 2] = "STOPPED";
    Wex_PlayerEvents[Wex_PlayerEvents["PLAYING"] = 3] = "PLAYING";
    Wex_PlayerEvents[Wex_PlayerEvents["PLAY_REQUESTED"] = 4] = "PLAY_REQUESTED";
    Wex_PlayerEvents[Wex_PlayerEvents["CLOSE_TO_END"] = 5] = "CLOSE_TO_END";
    Wex_PlayerEvents[Wex_PlayerEvents["ERROR"] = 6] = "ERROR";
    Wex_PlayerEvents[Wex_PlayerEvents["INITIALIZED"] = 7] = "INITIALIZED";
    Wex_PlayerEvents[Wex_PlayerEvents["STATE_UPDATED"] = 8] = "STATE_UPDATED";
    Wex_PlayerEvents[Wex_PlayerEvents["TRACK_UPDATED"] = 9] = "TRACK_UPDATED";
    Wex_PlayerEvents[Wex_PlayerEvents["POSITION_SYNC"] = 10] = "POSITION_SYNC";
    Wex_PlayerEvents[Wex_PlayerEvents["QUALITY_RESTRICTED"] = 11] = "QUALITY_RESTRICTED";
    Wex_PlayerEvents[Wex_PlayerEvents["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Wex_PlayerEvents || (Wex_PlayerEvents = {}));
export function wex_PlayerEventsFromJSON(object) {
    switch (object) {
        case 0:
        case "UNKNOWN_EVENT":
            return Wex_PlayerEvents.UNKNOWN_EVENT;
        case 1:
        case "PAUSED":
            return Wex_PlayerEvents.PAUSED;
        case 2:
        case "STOPPED":
            return Wex_PlayerEvents.STOPPED;
        case 3:
        case "PLAYING":
            return Wex_PlayerEvents.PLAYING;
        case 4:
        case "PLAY_REQUESTED":
            return Wex_PlayerEvents.PLAY_REQUESTED;
        case 5:
        case "CLOSE_TO_END":
            return Wex_PlayerEvents.CLOSE_TO_END;
        case 6:
        case "ERROR":
            return Wex_PlayerEvents.ERROR;
        case 7:
        case "INITIALIZED":
            return Wex_PlayerEvents.INITIALIZED;
        case 8:
        case "STATE_UPDATED":
            return Wex_PlayerEvents.STATE_UPDATED;
        case 9:
        case "TRACK_UPDATED":
            return Wex_PlayerEvents.TRACK_UPDATED;
        case 10:
        case "POSITION_SYNC":
            return Wex_PlayerEvents.POSITION_SYNC;
        case 11:
        case "QUALITY_RESTRICTED":
            return Wex_PlayerEvents.QUALITY_RESTRICTED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Wex_PlayerEvents.UNRECOGNIZED;
    }
}
export function wex_PlayerEventsToJSON(object) {
    switch (object) {
        case Wex_PlayerEvents.UNKNOWN_EVENT:
            return "UNKNOWN_EVENT";
        case Wex_PlayerEvents.PAUSED:
            return "PAUSED";
        case Wex_PlayerEvents.STOPPED:
            return "STOPPED";
        case Wex_PlayerEvents.PLAYING:
            return "PLAYING";
        case Wex_PlayerEvents.PLAY_REQUESTED:
            return "PLAY_REQUESTED";
        case Wex_PlayerEvents.CLOSE_TO_END:
            return "CLOSE_TO_END";
        case Wex_PlayerEvents.ERROR:
            return "ERROR";
        case Wex_PlayerEvents.INITIALIZED:
            return "INITIALIZED";
        case Wex_PlayerEvents.STATE_UPDATED:
            return "STATE_UPDATED";
        case Wex_PlayerEvents.TRACK_UPDATED:
            return "TRACK_UPDATED";
        case Wex_PlayerEvents.POSITION_SYNC:
            return "POSITION_SYNC";
        case Wex_PlayerEvents.QUALITY_RESTRICTED:
            return "QUALITY_RESTRICTED";
        case Wex_PlayerEvents.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseWex() {
    return {};
}
export const Wex = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWex();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Wex.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseWex();
        return message;
    },
};
function createBaseWex_Error() {
    return { errorType: undefined };
}
export const Wex_Error = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.errorType !== undefined) {
            writer.uint32(8).int32(message.errorType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWex_Error();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.errorType = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { errorType: isSet(object.errorType) ? wex_PlayerErrorsFromJSON(object.errorType) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.errorType !== undefined) {
            obj.errorType = wex_PlayerErrorsToJSON(message.errorType);
        }
        return obj;
    },
    create(base) {
        return Wex_Error.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWex_Error();
        message.errorType = object.errorType ?? undefined;
        return message;
    },
};
function createBaseWex_AudioTrack() {
    return { id: "", locale: "", label: undefined };
}
export const Wex_AudioTrack = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.locale !== "") {
            writer.uint32(18).string(message.locale);
        }
        if (message.label !== undefined) {
            writer.uint32(26).string(message.label);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWex_AudioTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.locale = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.label = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            locale: isSet(object.locale) ? globalThis.String(object.locale) : "",
            label: isSet(object.label) ? globalThis.String(object.label) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.locale !== "") {
            obj.locale = message.locale;
        }
        if (message.label !== undefined) {
            obj.label = message.label;
        }
        return obj;
    },
    create(base) {
        return Wex_AudioTrack.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWex_AudioTrack();
        message.id = object.id ?? "";
        message.locale = object.locale ?? "";
        message.label = object.label ?? undefined;
        return message;
    },
};
function createBaseWex_PlayerState() {
    return {
        streamType: undefined,
        programStartMs: undefined,
        programEndMs: undefined,
        streamStartMs: undefined,
        streamEndMs: undefined,
        currentMs: undefined,
        canPlay: undefined,
        canPause: undefined,
        canForward: undefined,
        canBackward: undefined,
        canPlayLive: undefined,
        canPlayFromStart: undefined,
        buffering: undefined,
        paused: undefined,
        playing: undefined,
        stopped: undefined,
        hasSeekForwardPermission: undefined,
        hasSeekBackwardPermission: undefined,
        volume: undefined,
        audioTracks: [],
        currentAudioTrack: undefined,
    };
}
export const Wex_PlayerState = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.streamType !== undefined) {
            writer.uint32(8).int32(message.streamType);
        }
        if (message.programStartMs !== undefined) {
            writer.uint32(16).int64(message.programStartMs);
        }
        if (message.programEndMs !== undefined) {
            writer.uint32(24).int64(message.programEndMs);
        }
        if (message.streamStartMs !== undefined) {
            writer.uint32(32).int64(message.streamStartMs);
        }
        if (message.streamEndMs !== undefined) {
            writer.uint32(40).int64(message.streamEndMs);
        }
        if (message.currentMs !== undefined) {
            writer.uint32(48).int64(message.currentMs);
        }
        if (message.canPlay !== undefined) {
            writer.uint32(56).bool(message.canPlay);
        }
        if (message.canPause !== undefined) {
            writer.uint32(64).bool(message.canPause);
        }
        if (message.canForward !== undefined) {
            writer.uint32(72).bool(message.canForward);
        }
        if (message.canBackward !== undefined) {
            writer.uint32(80).bool(message.canBackward);
        }
        if (message.canPlayLive !== undefined) {
            writer.uint32(88).bool(message.canPlayLive);
        }
        if (message.canPlayFromStart !== undefined) {
            writer.uint32(96).bool(message.canPlayFromStart);
        }
        if (message.buffering !== undefined) {
            writer.uint32(104).bool(message.buffering);
        }
        if (message.paused !== undefined) {
            writer.uint32(112).bool(message.paused);
        }
        if (message.playing !== undefined) {
            writer.uint32(120).bool(message.playing);
        }
        if (message.stopped !== undefined) {
            writer.uint32(128).bool(message.stopped);
        }
        if (message.hasSeekForwardPermission !== undefined) {
            writer.uint32(136).bool(message.hasSeekForwardPermission);
        }
        if (message.hasSeekBackwardPermission !== undefined) {
            writer.uint32(144).bool(message.hasSeekBackwardPermission);
        }
        if (message.volume !== undefined) {
            writer.uint32(152).int32(message.volume);
        }
        for (const v of message.audioTracks) {
            Wex_AudioTrack.encode(v, writer.uint32(162).fork()).ldelim();
        }
        if (message.currentAudioTrack !== undefined) {
            Wex_AudioTrack.encode(message.currentAudioTrack, writer.uint32(170).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWex_PlayerState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.streamType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.programStartMs = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.programEndMs = longToNumber(reader.int64());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.streamStartMs = longToNumber(reader.int64());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.streamEndMs = longToNumber(reader.int64());
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.currentMs = longToNumber(reader.int64());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.canPlay = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.canPause = reader.bool();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.canForward = reader.bool();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.canBackward = reader.bool();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.canPlayLive = reader.bool();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.canPlayFromStart = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.buffering = reader.bool();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.paused = reader.bool();
                    continue;
                case 15:
                    if (tag !== 120) {
                        break;
                    }
                    message.playing = reader.bool();
                    continue;
                case 16:
                    if (tag !== 128) {
                        break;
                    }
                    message.stopped = reader.bool();
                    continue;
                case 17:
                    if (tag !== 136) {
                        break;
                    }
                    message.hasSeekForwardPermission = reader.bool();
                    continue;
                case 18:
                    if (tag !== 144) {
                        break;
                    }
                    message.hasSeekBackwardPermission = reader.bool();
                    continue;
                case 19:
                    if (tag !== 152) {
                        break;
                    }
                    message.volume = reader.int32();
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.audioTracks.push(Wex_AudioTrack.decode(reader, reader.uint32()));
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.currentAudioTrack = Wex_AudioTrack.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            streamType: isSet(object.streamType) ? wex_WexStreamTypeFromJSON(object.streamType) : undefined,
            programStartMs: isSet(object.programStartMs) ? globalThis.Number(object.programStartMs) : undefined,
            programEndMs: isSet(object.programEndMs) ? globalThis.Number(object.programEndMs) : undefined,
            streamStartMs: isSet(object.streamStartMs) ? globalThis.Number(object.streamStartMs) : undefined,
            streamEndMs: isSet(object.streamEndMs) ? globalThis.Number(object.streamEndMs) : undefined,
            currentMs: isSet(object.currentMs) ? globalThis.Number(object.currentMs) : undefined,
            canPlay: isSet(object.canPlay) ? globalThis.Boolean(object.canPlay) : undefined,
            canPause: isSet(object.canPause) ? globalThis.Boolean(object.canPause) : undefined,
            canForward: isSet(object.canForward) ? globalThis.Boolean(object.canForward) : undefined,
            canBackward: isSet(object.canBackward) ? globalThis.Boolean(object.canBackward) : undefined,
            canPlayLive: isSet(object.canPlayLive) ? globalThis.Boolean(object.canPlayLive) : undefined,
            canPlayFromStart: isSet(object.canPlayFromStart) ? globalThis.Boolean(object.canPlayFromStart) : undefined,
            buffering: isSet(object.buffering) ? globalThis.Boolean(object.buffering) : undefined,
            paused: isSet(object.paused) ? globalThis.Boolean(object.paused) : undefined,
            playing: isSet(object.playing) ? globalThis.Boolean(object.playing) : undefined,
            stopped: isSet(object.stopped) ? globalThis.Boolean(object.stopped) : undefined,
            hasSeekForwardPermission: isSet(object.hasSeekForwardPermission)
                ? globalThis.Boolean(object.hasSeekForwardPermission)
                : undefined,
            hasSeekBackwardPermission: isSet(object.hasSeekBackwardPermission)
                ? globalThis.Boolean(object.hasSeekBackwardPermission)
                : undefined,
            volume: isSet(object.volume) ? globalThis.Number(object.volume) : undefined,
            audioTracks: globalThis.Array.isArray(object?.audioTracks)
                ? object.audioTracks.map((e) => Wex_AudioTrack.fromJSON(e))
                : [],
            currentAudioTrack: isSet(object.currentAudioTrack)
                ? Wex_AudioTrack.fromJSON(object.currentAudioTrack)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.streamType !== undefined) {
            obj.streamType = wex_WexStreamTypeToJSON(message.streamType);
        }
        if (message.programStartMs !== undefined) {
            obj.programStartMs = Math.round(message.programStartMs);
        }
        if (message.programEndMs !== undefined) {
            obj.programEndMs = Math.round(message.programEndMs);
        }
        if (message.streamStartMs !== undefined) {
            obj.streamStartMs = Math.round(message.streamStartMs);
        }
        if (message.streamEndMs !== undefined) {
            obj.streamEndMs = Math.round(message.streamEndMs);
        }
        if (message.currentMs !== undefined) {
            obj.currentMs = Math.round(message.currentMs);
        }
        if (message.canPlay !== undefined) {
            obj.canPlay = message.canPlay;
        }
        if (message.canPause !== undefined) {
            obj.canPause = message.canPause;
        }
        if (message.canForward !== undefined) {
            obj.canForward = message.canForward;
        }
        if (message.canBackward !== undefined) {
            obj.canBackward = message.canBackward;
        }
        if (message.canPlayLive !== undefined) {
            obj.canPlayLive = message.canPlayLive;
        }
        if (message.canPlayFromStart !== undefined) {
            obj.canPlayFromStart = message.canPlayFromStart;
        }
        if (message.buffering !== undefined) {
            obj.buffering = message.buffering;
        }
        if (message.paused !== undefined) {
            obj.paused = message.paused;
        }
        if (message.playing !== undefined) {
            obj.playing = message.playing;
        }
        if (message.stopped !== undefined) {
            obj.stopped = message.stopped;
        }
        if (message.hasSeekForwardPermission !== undefined) {
            obj.hasSeekForwardPermission = message.hasSeekForwardPermission;
        }
        if (message.hasSeekBackwardPermission !== undefined) {
            obj.hasSeekBackwardPermission = message.hasSeekBackwardPermission;
        }
        if (message.volume !== undefined) {
            obj.volume = Math.round(message.volume);
        }
        if (message.audioTracks?.length) {
            obj.audioTracks = message.audioTracks.map((e) => Wex_AudioTrack.toJSON(e));
        }
        if (message.currentAudioTrack !== undefined) {
            obj.currentAudioTrack = Wex_AudioTrack.toJSON(message.currentAudioTrack);
        }
        return obj;
    },
    create(base) {
        return Wex_PlayerState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWex_PlayerState();
        message.streamType = object.streamType ?? undefined;
        message.programStartMs = object.programStartMs ?? undefined;
        message.programEndMs = object.programEndMs ?? undefined;
        message.streamStartMs = object.streamStartMs ?? undefined;
        message.streamEndMs = object.streamEndMs ?? undefined;
        message.currentMs = object.currentMs ?? undefined;
        message.canPlay = object.canPlay ?? undefined;
        message.canPause = object.canPause ?? undefined;
        message.canForward = object.canForward ?? undefined;
        message.canBackward = object.canBackward ?? undefined;
        message.canPlayLive = object.canPlayLive ?? undefined;
        message.canPlayFromStart = object.canPlayFromStart ?? undefined;
        message.buffering = object.buffering ?? undefined;
        message.paused = object.paused ?? undefined;
        message.playing = object.playing ?? undefined;
        message.stopped = object.stopped ?? undefined;
        message.hasSeekForwardPermission = object.hasSeekForwardPermission ?? undefined;
        message.hasSeekBackwardPermission = object.hasSeekBackwardPermission ?? undefined;
        message.volume = object.volume ?? undefined;
        message.audioTracks = object.audioTracks?.map((e) => Wex_AudioTrack.fromPartial(e)) || [];
        message.currentAudioTrack = (object.currentAudioTrack !== undefined && object.currentAudioTrack !== null)
            ? Wex_AudioTrack.fromPartial(object.currentAudioTrack)
            : undefined;
        return message;
    },
};
function createBaseWex_PlayerOutput() {
    return {};
}
export const Wex_PlayerOutput = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWex_PlayerOutput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Wex_PlayerOutput.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseWex_PlayerOutput();
        return message;
    },
};
function createBaseWex_PlayerOutput_Properties() {
    return { event: undefined, state: undefined, error: undefined };
}
export const Wex_PlayerOutput_Properties = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.event !== undefined) {
            writer.uint32(8).int32(message.event);
        }
        if (message.state !== undefined) {
            Wex_PlayerState.encode(message.state, writer.uint32(18).fork()).ldelim();
        }
        if (message.error !== undefined) {
            Wex_Error.encode(message.error, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWex_PlayerOutput_Properties();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.event = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.state = Wex_PlayerState.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.error = Wex_Error.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            event: isSet(object.event) ? wex_PlayerEventsFromJSON(object.event) : undefined,
            state: isSet(object.state) ? Wex_PlayerState.fromJSON(object.state) : undefined,
            error: isSet(object.error) ? Wex_Error.fromJSON(object.error) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.event !== undefined) {
            obj.event = wex_PlayerEventsToJSON(message.event);
        }
        if (message.state !== undefined) {
            obj.state = Wex_PlayerState.toJSON(message.state);
        }
        if (message.error !== undefined) {
            obj.error = Wex_Error.toJSON(message.error);
        }
        return obj;
    },
    create(base) {
        return Wex_PlayerOutput_Properties.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWex_PlayerOutput_Properties();
        message.event = object.event ?? undefined;
        message.state = (object.state !== undefined && object.state !== null)
            ? Wex_PlayerState.fromPartial(object.state)
            : undefined;
        message.error = (object.error !== undefined && object.error !== null)
            ? Wex_Error.fromPartial(object.error)
            : undefined;
        return message;
    },
};
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
